import $ from 'jquery'
import DateFilter from '@/components/date-filter';
import CancelInvoice from '@/components/caisse/factures/cancel-invoice'

export default {
    name: 'facture-assurance',
    components: {
        DateFilter, CancelInvoice
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'ref', label: 'Référence' }, { key: 'assurance', label: 'Assurance' }, 'date',
                { key: 'action', label: 'Action.s' }
            ],

            filter: "",
            perPage: 15,
            print_per_page: -1,
            currentPage: 1,

            seleted_assurance: '',
            selected_invoice: {},
            is_facture_assurance: 1
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                assurance_id: this.current_date_filter?.assurance_id,
            }
            this.current_date_filter = data
            this.getListeFactureAssurance(this.current_date_filter)
        },

        seleted_assurance() {
            this.current_date_filter.assurance_id = (this.seleted_assurance != null)?this.seleted_assurance?.id:''
            this.getListeFactureAssurance(this.current_date_filter)
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        assurances() {
            return this.$store.getters["assurances"];
        },

        factures_assurance() {
            return this.$store.getters["factures_assurance"];
        },

        factures_assurance_length() {
            return this.factures_assurance.length
        }
    },

    mounted() {
        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js

        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]

        this.$store.dispatch("getAssurances")
    },

    methods: {
        refreshInvoice() {
            this.getListeFactureAssurance(this.current_date_filter)
        },

        getListeFactureAssurance(data) {
            this.is_load_error = false
            this.is_loading = true
            this.$store.dispatch("getListeFactureAssurance", data).then(() => {
                if (this.factures_assurance.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            this.selected_operations = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                assurance_id: this.current_date_filter?.assurance_id
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.getListeFactureAssurance(data)
        },

        viewDetail(facture) {
            console.log(facture);
            this.$store.commit("SET_SELECTED_INSURANCE_BILL", facture);
            setTimeout(() => {
                this.$router.push({ path: '/factures/detail-remboursement' })
            }, 500);
        },

        setInvoiceToCancel(facture) {
            console.log(facture);
            this.selected_invoice = {
                facture_id: facture.facture_id,
                reference: facture.reference,
                assurance: facture.assurance.compagnie
            }

            setTimeout(() => {
                $('.cancel-assur-invoice').modal('show')
            }, 500);
        }
    }
}